import React from 'react'
import PropTypes from 'prop-types'

export default class Main extends React.Component {
  render() {
    return (
      <div className="Main">
        <div className="inner">
          <div className="Split">
            <div className="Split-left">
              <h1 className="heading-dark">
                Adviseren <em>&</em> Bemiddelen
              </h1>
              <p>
                <strong>
                  We zijn onafhankelijk adviseur en hebben dus maar één belang:
                  dat van jou.
                </strong>{' '}
                We vergelijken verschillende banken en
                verzekeringsmaatschappijen met elkaar, totdat we de hypotheek of
                verzekering vinden die het beste bij jouw situatie past. Qua
                voorwaarden, maar zeker ook qua prijs.
              </p>

              <p>
                <strong>
                  Met een hypotheek- en/of verzekeringstraject helpen we je van
                  de eerste stap tot de laatste.
                </strong>{' '}
                Of het nu gaat om het contact met de notaris en makelaar, het
                regelen van een starterslening of het vergelijken van de
                verzekeringsvoorwaarden: wij regisseren het.
              </p>

              <p>
                <strong>
                  Wij zorgen dat alles draait en jij hoeft je alleen maar druk
                  te maken over de inrichting van je huis of de kleur van je
                  auto.
                </strong>
              </p>
            </div>
            <aside className="Main-sidebar Split-right">
              <h2>Hoe we met je samenwerken</h2>
              <ol>
                <li>We maken kennis</li>
                <li>We inventariseren</li>
                <li>We adviseren</li>
                <li>We bemiddelen</li>
                <li>We houden contact</li>
              </ol>
            </aside>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Main.js